import { ActivationComponentAssets } from "./ActivationAssets";

const getIsActivationLimitReached = (existingActivationSets?: number) => {
    const limit = ActivationComponentAssets.activationSetsLimitation;

    return existingActivationSets ? existingActivationSets >= limit : false;
};

export default getIsActivationLimitReached;
